<!-- 3.- Calendario del index-->
<div class="brook-portfolio-area pt--100 rslide" data-background="#ae2883" style="background-color: #ff7e43; padding-top:150px; padding-bottom: 40px;">
    <div class="container-fluid plr--100 plr_sm--30 plr_md--50">
        <div class="row">
            <div class="col-lg-12">
                <div class="brook-section-title mb--30 text-center">
                    <h6 class="heading heading-h6 text-white letter-spacing-3">Envía un WhatsApp para darte de alta en el curso</h6>
                    <div class="space mb--45"></div>
                    <h3 class="heading heading-h3 text-white font-40">PRÓXIMOS EVENTOS</h3>
                </div>
            </div>
        </div>
            
            <div class="row">
            
            <!-- Evento 1 -->
            <div class="col-lg-3 col-sm-6 col-12 move-up wow mt--60">
                <div class="blog-grid-minimal minimal-style-2 text-white">
                    <div class="post-content">
                        <div class="post-meta">
                            <div class="post-date"> 6 de Marzo, 2020</div>
                            <div class="post-category"><a href="https://api.whatsapp.com/send?phone=5219611811608&text=Hola!" target="_blank">Info vía WhatsApp</a></div>
                        </div>
                        <h4 class="heading heading-h4 line-height-1-62"><a href="curso-activador-akashico-2.php" target="_blank">
                                Activador Akashico® II</a></h4>
                        <div class="post-author">
                            <h6 class="heading heading-h6">Tuxtla Gutiérrez, Chiapas</h6>
                        </div>
                    </div>
                </div>
            </div>
           
            <!-- Evento 2 -->
            <div class="col-lg-3 col-sm-6 col-12 move-up wow mt--60">
                <div class="blog-grid-minimal minimal-style-2 text-white">
                    <div class="post-content">
                        <div class="post-meta">
                            <div class="post-date">7 de Marzo, 2020</div>
                            <div class="post-category"><a href="https://api.whatsapp.com/send?phone=5219611811608&text=Hola!" target="_blank">Info vía WhatsApp</a></div>
                        </div>
                        <h4 class="heading heading-h4 line-height-1-62"><a href="curso-activador-akashico-cristales.php" target="_blank">
                                Activador Akashico® Cristales</a></h4>
                        <div class="post-author">
                            <h6 class="heading heading-h6">Tuxtla Gutiérrez, Chiapas</h6>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Evento 3 -->
            <div class="<col-lg-3 col-lg-3 col-sm-6 col-12 move-up wow mt--60">
                <div class="blog-grid-minimal minimal-style-2 text-white">
                    <div class="post-content">
                        <div class="post-meta">
                            <div class="post-date">8 de Marzo, 2020</div>
                            <div class="post-category"><a href="https://api.whatsapp.com/send?phone=5219611811608&text=Hola!" target="_blank">Info vía WhatsApp</a></div>
                        </div>
                        <h4 class="heading heading-h4 line-height-1-62"><a>
                                Activador Akashico® Empresas, Negocios y Corporaciones</a></h4>
                        <div class="post-author">
                            <h6 class="heading heading-h6">Tuxtla Gutiérrez, Chiapas</h6>
                        </div>
                    </div>
                </div>
            </div>
            
             <!-- Evento 4 -->
            <div class="<col-lg-3 col-lg-3 col-sm-6 col-12 move-up wow mt--60">
                <div class="blog-grid-minimal minimal-style-2 text-white">
                    <div class="post-content">
                        <div class="post-meta">
                            <div class="post-date">9 de Marzo, 2020</div>
                            <div class="post-category"><a href="https://api.whatsapp.com/send?phone=5219611811608&text=Hola!" target="_blank">Info vía WhatsApp</a></div>
                        </div>
                        <h4 class="heading heading-h4 line-height-1-62"><a href="curso-conexion-akashico.php" target="_blank">
                                Conexión Akashico®</a></h4>
                        <div class="post-author">
                            <h6 class="heading heading-h6">Tuxtla Gutiérrez, Chiapas</h6>
                        </div>
                    </div>
                </div>
            </div>
            
             <!-- Evento 5 -->
            <div class="col-lg-3 col-sm-6 col-12 move-up wow mt--60">
                <div class="blog-grid-minimal minimal-style-2 text-white">
                    <div class="post-content">
                        <div class="post-meta">
                            <div class="post-date">10 de Marzo, 2020</div>
                            <div class="post-category"><a href="https://api.whatsapp.com/send?phone=5219611811608&text=Hola!" target="_blank">Info vía WhatsApp</a></div>
                        </div>
                        <h4 class="heading heading-h4 line-height-1-62"><a href="curso-sistemaderedes-nuroakashico.php" target="_blank">
                                Sistema de Redes NeuroAkashico®</a></h4>
                        <div class="post-author">
                            <h6 class="heading heading-h6">Tuxtla Gutiérrez, Chiapas</h6>
                        </div>
                    </div>
                </div>
            </div>
           
            <!-- Evento 6 -->
            <div class="col-lg-3 col-sm-6 col-12 move-up wow mt--60">
                <div class="blog-grid-minimal minimal-style-2 text-white">
                    <div class="post-content">
                        <div class="post-meta">
                            <div class="post-date">14 de Marzo, 2020</div>
                            <div class="post-category"><a href="https://api.whatsapp.com/send?phone=5219611811608&text=Hola!" target="_blank">Info vía WhatsApp</a></div>
                        </div>
                        <h4 class="heading heading-h4 line-height-1-62"><a href="curso-activador-akashico-luz-ilimitada.php" target="_blank">
                                Activador Akashico® Luz ilimitada®</a></h4>
                        <div class="post-author">
                            <h6 class="heading heading-h6">Tuxtla Gutiérrez, Chiapas</h6>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Evento 7 -->
            <div class="<col-lg-3 col-lg-3 col-sm-6 col-12 move-up wow mt--60">
                <div class="blog-grid-minimal minimal-style-2 text-white">
                    <div class="post-content">
                        <div class="post-meta">
                            <div class="post-date">15 de Marzo, 2020</div>
                            <div class="post-category"><a href="https://api.whatsapp.com/send?phone=5219611811608&text=Hola!" target="_blank">Info vía WhatsApp</a></div>
                        </div>
                        <h4 class="heading heading-h4 line-height-1-62"><a>
                               Activador Akashico® Niños</a></h4>
                        <div class="post-author">
                            <h6 class="heading heading-h6">Tuxtla Gutiérrez, Chiapas</h6>
                        </div>
                    </div>
                </div>
            </div>
            
             <!-- Evento 8 -->
            <div class="<col-lg-3 col-lg-3 col-sm-6 col-12 move-up wow mt--60">
                <div class="blog-grid-minimal minimal-style-2 text-white">
                    <div class="post-content">
                        <div class="post-meta">
                            <div class="post-date">16 de Marzo, 2020</div>
                            <div class="post-category"><a href="https://api.whatsapp.com/send?phone=5219611811608&text=Hola!" target="_blank">Info vía WhatsApp</a></div>
                        </div>
                        <h4 class="heading heading-h4 line-height-1-62"><a href="curso-neuro-akashico-gran-sistema.php" target="_blank">
                                NeuroAkashico® Gran Sistema de Redes</a></h4>
                        <div class="post-author">
                            <h6 class="heading heading-h6">Tuxtla Gutiérrez, Chiapas</h6>
                        </div>
                    </div>
                </div>
            </div>
            
             <!-- Evento 9 Largo -->
            <div class="<col-lg-6 col-lg-6 col-sm-12 col-12 move-up wow mt--60">
                <div class="blog-grid-minimal minimal-style-2 text-white">
                    <div class="post-content">
                        <div class="post-meta">
                            <div class="post-date">21 y 22 de Marzo, 2020</div>
                            <div class="post-category"><a href="https://api.whatsapp.com/send?phone=5219611811608&text=Hola!" target="_blank">Info vía WhatsApp</a></div>
                        </div>
                        <h4 class="heading heading-h4 line-height-1-62"><a>
                               Festival NeuroAkashico® presentado por Akashic School Inc, presencial y modalidad virtual en plataforma E-Learning </a></h4>
                        <div class="post-author">
                            <h6 class="heading heading-h6">Tuxtla Gutiérrez, Chiapas</h6>
                        </div>
                    </div>
                </div>
            </div>
            
             <!-- Evento 10 -->
            <div class="<col-lg-3 col-lg-3 col-sm-6 col-12 move-up wow mt--60">
                <div class="blog-grid-minimal minimal-style-2 text-white">
                    <div class="post-content">
                        <div class="post-meta">
                            <div class="post-date">28 de Marzo, 2020</div>
                            <div class="post-category"><a href="https://api.whatsapp.com/send?phone=5219611811608&text=Hola!" target="_blank">Info vía WhatsApp</a></div>
                        </div>
                        <h4 class="heading heading-h4 line-height-1-62"><a href="curso-activador-akashico-luz-ilimitada.php" target="_blank">
                                Activador Akashico® Luz Ilimitada® Practicante y Facilitador</a></h4>
                        <div class="post-author">
                            <h6 class="heading heading-h6">Playa del Carmen, Quintana Roo</h6>
                        </div>
                    </div>
                </div>
            </div>
            
             <!-- Evento 11 -->
            <div class="<col-lg-3 col-lg-3 col-sm-6 col-12 move-up wow mt--60">
                <div class="blog-grid-minimal minimal-style-2 text-white">
                    <div class="post-content">
                        <div class="post-meta">
                            <div class="post-date">28 de Marzo, 2020</div>
                            <div class="post-category"><a href="https://api.whatsapp.com/send?phone=5219611811608&text=Hola!" target="_blank">Info vía WhatsApp</a></div>
                        </div>
                        <h4 class="heading heading-h4 line-height-1-62"><a href="curso-activador-akashico-luz-ilimitada.php" target="_blank">
                                Activador Akashico® Luz Ilimitada®, Practicante y Facilitador</a></h4>
                        <div class="post-author">
                            <h6 class="heading heading-h6">Playa del Carmen, Quintana Roo</h6>
                        </div>
                    </div>
                </div>
            </div>
            
                <!-- Evento 11 -->
            <div class="<col-lg-3 col-lg-3 col-sm-6 col-12 move-up wow mt--60">
                <div class="blog-grid-minimal minimal-style-2 text-white">
                    <div class="post-content">
                        <div class="post-meta">
                            <div class="post-date">29 de Marzo, 2020</div>
                            <div class="post-category"><a href="https://api.whatsapp.com/send?phone=5219611811608&text=Hola!" target="_blank">Info vía WhatsApp</a></div>
                        </div>
                        <h4 class="heading heading-h4 line-height-1-62"><a href="curso-activador-akashico-2.php" target="_blank">
                                Activador Akashico® II, Practicante y Facilitador </a></h4>
                        <div class="post-author">
                            <h6 class="heading heading-h6">Playa del Carmen, Quintana Roo</h6>
                        </div>
                    </div>
                </div>
            </div>
            
             <!-- Evento 11 -->
            <div class="<col-lg-3 col-lg-3 col-sm-6 col-12 move-up wow mt--60">
                <div class="blog-grid-minimal minimal-style-2 text-white">
                    <div class="post-content">
                        <div class="post-meta">
                            <div class="post-date">30 de Marzo, 2020</div>
                            <div class="post-category"><a href="https://api.whatsapp.com/send?phone=5219611811608&text=Hola!" target="_blank">Info vía WhatsApp</a></div>
                        </div>
                        <h4 class="heading heading-h4 line-height-1-62"><a href="curso-activador-akashico-cristales.php" target="_blank">
                                 Activador Akashico® Cristales </a></h4>
                        <div class="post-author">
                            <h6 class="heading heading-h6">Playa del Carmen, Quintana Roo</h6>
                        </div>
                    </div>
                </div>
            </div>
          
          
          </div>
       
    </div>
</div>

